/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Language specific subject and content of message
 */
export interface MessageContent { 
    /**
     * Message Subject
     */
    subject: string;
    /**
     * Label name for action redirect URI
     */
    action_label?: string;
    /**
     * URL to redirect for action or further description
     */
    action_redirect?: string;
    /**
     * Text or HTML Content
     */
    content: string;
    /**
     * Message language
     */
    language: MessageContent.LanguageEnum;
}
export namespace MessageContent {
    export type LanguageEnum = 'en' | 'fr' | 'ja' | 'es' | 'de' | 'ko' | 'zh-Hant' | 'zh-Hans';
    export const LanguageEnum = {
        EN: 'en' as LanguageEnum,
        FR: 'fr' as LanguageEnum,
        JA: 'ja' as LanguageEnum,
        ES: 'es' as LanguageEnum,
        DE: 'de' as LanguageEnum,
        KO: 'ko' as LanguageEnum,
        ZH_HANT: 'zh-Hant' as LanguageEnum,
        ZH_HANS: 'zh-Hans' as LanguageEnum
    };
}


